import { Spin } from 'antd';
import useLegacyGameActivity from './useLegacyGameActivity.hook';
import { StyledLegacyGameActivity } from './LegacyGameActivity.styled';
import { useContext, useRef } from 'react';
import { FullscreenContext } from '@/shared/FullscreenContext/FullscreenContext';
import AspectRatio from '@/shared/AspectRatio/AspectRatio';
import AnimatedStars from '@/shared/StudentPage/StudentPageTopbar/GamificationScoreBoard/AnimatedStars/AnimatedStars';
import { ANCHOR } from '@/modules/dom/getElementCoordinates';
import { GameControlBar } from '../GameControlBar/GameControlBar';

export default function LegacyGameActivity({
  activity,
  activityConf,
  taskProgressActions,
  demoMode,
}) {
  const fullscreenContext = useContext(FullscreenContext);
  const frame = useRef(null);
  const parentDivRef = useRef();
  const gameType = activity.data?.subType || activity.type;
  const { state, actions } = useLegacyGameActivity({
    frame,
    activity,
    activityConf,
    taskProgressActions,
    demoMode,
    gameType,
    fullscreenContext,
  });

  const aspectRatio = getAspectRatio(
    gameType,
    fullscreenContext.state.isFullscreen
  );

  return (
    <StyledLegacyGameActivity
      className={`${fullscreenContext.state.isFullscreen ? 'fullscreen' : ''}`}
      ref={parentDivRef}
      tabIndex={0}
    >
      <AnimatedStars
        originSelector="iframe"
        originAnchor={ANCHOR.TOPLEFT}
        iframeStarsOrigin={state.iframeStarsOrigin}
      />
      <AspectRatio ratio={aspectRatio} className="aspect-ratio">
        <Spin wrapperClassName="spinner-wrapper" spinning={!state.gameReady}>
          {state.gameListenerReady ? (
            <iframe
              ref={frame}
              src={state.gameSrc}
              onLoad={actions.onIframeLoad}
            ></iframe>
          ) : null}
        </Spin>
        <GameControlBar
          state={state}
          actions={actions}
          activityConf={activityConf}
          parentDivRef={parentDivRef}
        />
      </AspectRatio>
    </StyledLegacyGameActivity>
  );
}

function getAspectRatio(gameType, isFullscreen) {
  return {
    shortStory: (16 / 8) * (isFullscreen ? 1 : 0.65),
    game: 11 / 7,
    imagesQuiz: 15 / 9,
    quiz: 16 / 9,
    bubbles: 16 / 11,
    skate: 16 / 9,
  }[gameType];
}
